import React, { FC, useMemo, useState } from "react";
import SearchInput from "./SearchInput";
import OptionGrid from "./OptionGrid";
import NoSearchResults from "./NoSearchResults";
import styles from "../../../styles/B2C/StepLayout.module.scss";
import { useWizardOptions } from "../../../context/WizardOptionsContext";

// Sentinel option always shown last. Selecting it sends looking_for_coaching = 'No'.
export const COACHING_NOT_INTERESTED = "Not Interested";

interface CoachingStepProps {
  selected: string;
  onSelect: (coaching: string) => void;
}

const CoachingStep: FC<CoachingStepProps> = ({ selected, onSelect }) => {
  const { coachingOptions } = useWizardOptions();

  const [search, setSearch] = useState("");

  // Frappe courses + a trailing "Not Interested" (always present, even if the list is empty).
  const options = useMemo(() => {
    const courses = (coachingOptions ?? [])
      .map((coaching) => coaching.label)
      .filter(Boolean);
    return [...courses, COACHING_NOT_INTERESTED];
  }, [coachingOptions]);

  const filteredOptions = useMemo(() => {
    if (!search.trim()) return options;
    return options.filter((label) =>
      label.toLowerCase().includes(search.toLowerCase())
    );
  }, [search, options]);

  return (
    <div className={styles.stepContent}>
      <SearchInput value={search} onChange={setSearch} placeholder="Search..." sticky />
      {search.trim() !== "" && filteredOptions.length === 0 ? (
        <NoSearchResults />
      ) : (
        <OptionGrid
          options={filteredOptions}
          selected={selected ? [selected] : []}
          onSelect={onSelect}
          multiSelect={false}
        />
      )}
    </div>
  );
};

export default CoachingStep;
